import { addCommas, fractionalDecimalDisplay } from './price-calculator'

export function updatePriceBreakChart(button) {
  const priceBreaks = getPriceBreaks(button)
  const listElement = document.querySelector('.price-break-list')
  
  if (!listElement) return
  
  listElement.innerHTML = ''
  
  priceBreaks.forEach((breakItem, index) => {
    const rangeText = buildPriceBreakRange(breakItem, priceBreaks[index + 1])
    const priceText = addCommas(fractionalDecimalDisplay(breakItem.price))
    
    const item = document.createElement('div')
    item.className = 'pricebreak-item'
    item.textContent = `${rangeText} : $${priceText}`
    
    listElement.appendChild(item)
  })
}

export function updatePriceBreakPerItemValue(element) {
  const selectedButton = document.querySelector('.uom-picker-button.selected')
  const priceBreaks = getPriceBreaks(selectedButton)
  const displayElement = document.querySelector('.price-break-per-price')
  
  if (!displayElement) return
  
  // Get quantity from the passed element if it's the quantity input,
  // otherwise look up the quantity input directly
  const quantityInput = element?.classList?.contains('quantity') 
    ? element 
    : document.getElementById('quantity')
  
  const quantity = quantityInput ? Number(quantityInput.value) : 1
  const price = findPriceForQuantity(priceBreaks, quantity)
  
  displayElement.innerHTML = `$${addCommas(fractionalDecimalDisplay(price))}`
}

export function togglePriceBreakDisplay(button) {
  const priceBreaks = getPriceBreaks(button)
  const section = document.querySelector('.price-break-section')
  
  if (!section) return
  
  if (hasMeaningfulPriceBreaks(priceBreaks)) {
    section.classList.remove('hide')
  } else {
    section.classList.add('hide')
  }
}

function hasMeaningfulPriceBreaks(priceBreaks) {
  if (!priceBreaks || priceBreaks.length <= 1) return false
  
  const uniquePrices = new Set(priceBreaks.map(pb => pb.price))
  return uniquePrices.size > 1
}

function getPriceBreaks(button) {
  if (!button?.dataset.priceBreaks) return []
  
  try {
    return JSON.parse(button.dataset.priceBreaks)
  } catch (e) {
    console.error('Failed to parse price breaks:', e)
    return []
  }
}

function buildPriceBreakRange(currentBreak, nextBreak) {
  const startQty = currentBreak.quantity
  
  if (!nextBreak) {
    return `${startQty} and up`
  }
  
  const endQty = nextBreak.quantity - 1
  
  if (startQty === endQty) {
    return `${startQty}`
  }
  
  return `${startQty} - ${endQty}`
}

function findPriceForQuantity(priceBreaks, quantity) {
  let price = priceBreaks[0]?.price || 0
  
  for (const breakItem of priceBreaks) {
    if (quantity >= breakItem.quantity) {
      price = breakItem.price
    }
  }
  
  return price
}
